namespace $.$$ {

	export class $shm_hitalama_taskmanager_priority extends $.$shm_hitalama_taskmanager_priority {

		priority_color( priority: string ) {
			switch( priority ) {
				case 'high': return '#ff5b5b'
				case 'low': return '#47515d88'
				default: return '#55a8ff'
			}
		}

		value_color() {
			return this.priority_color( this.value() )
		}

	}

}
